(function () {
  'use strict';

  if (window.YFCustomLiquidSafetyLoaded) {
    if (typeof window.YFInitCustomLiquidSafety === 'function') {
      window.YFInitCustomLiquidSafety(document);
    }
    return;
  }

  window.YFCustomLiquidSafetyLoaded = true;

  var safeExistingWrappers = [
    '.yf-custom-liquid-table-scroll',
    '.table-wrap',
    '.yf-new-table-wrap',
    '.yf-fallback-table-wrap'
  ].join(',');

  function wrapTable(table) {
    if (!table || !table.parentNode || table.closest(safeExistingWrappers)) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'yf-custom-liquid-table-scroll';
    wrapper.setAttribute('role', 'region');
    wrapper.setAttribute('aria-label', 'Scrollable product details table');
    wrapper.setAttribute('tabindex', '0');

    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  }

  function makeRootSafe(root) {
    if (!root || root.nodeType !== 1) return;

    root.querySelectorAll('table').forEach(wrapTable);

    if (root.dataset.yfTableObserverAttached === 'true') return;
    root.dataset.yfTableObserverAttached = 'true';

    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        root.querySelectorAll('table').forEach(wrapTable);
      });
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  function init(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;

    if (context.matches && context.matches('[data-yf-custom-liquid-safe]')) {
      makeRootSafe(context);
    }

    context.querySelectorAll('[data-yf-custom-liquid-safe]').forEach(makeRootSafe);
  }

  window.YFInitCustomLiquidSafety = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
